import { render, staticRenderFns } from "./FileManageEdit.vue?vue&type=template&id=61a0f646&scoped=true&"
import script from "./FileManageEdit.vue?vue&type=script&lang=js&"
export * from "./FileManageEdit.vue?vue&type=script&lang=js&"
import style0 from "./FileManageEdit.vue?vue&type=style&index=0&id=61a0f646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a0f646",
  null
  
)

export default component.exports